export const aboutContent = {
  brandName: "哈哈漫画网",
  tagline: "韩国漫画免费在线观看 - 高清韩漫全集下拉式阅读平台",
  introduction: "哈哈漫画网成立于2023年，是国内领先的韩国漫画在线阅读平台。我们致力于为广大韩漫爱好者提供高清、流畅、免费的漫画阅读体验。平台收录了数千部优质韩国漫画作品，涵盖恋爱、奇幻、动作、剧情、搞笑、悬疑、耽美、百合等多种类型，满足不同读者的阅读需求。",
  features: [
    {
      title: "高清画质",
      description: "所有漫画均采用高清分辨率呈现，细节清晰可见，为您带来极致的视觉享受。",
      icon: "ri-image-line",
    },
    {
      title: "下拉式阅读",
      description: "创新的下拉式阅读模式，无需翻页，一气呵成，让阅读更加流畅自然。",
      icon: "ri-scroll-to-bottom-line",
    },
    {
      title: "海量资源",
      description: "拥有超过5000部韩国漫画资源，每日更新，确保您不错过任何精彩内容。",
      icon: "ri-database-2-line",
    },
    {
      title: "完全免费",
      description: "所有漫画内容完全免费，无需付费即可畅读全站漫画，让好内容触手可及。",
      icon: "ri-vip-crown-line",
    },
  ],
  reputation: [
    {
      username: "漫画控小王",
      avatar: "https://readdy.ai/api/search-image?query=Close%20up%20portrait%20of%20a%20young%20Asian%20man%20with%20glasses%20smiling%20naturally%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=64&height=64&seq=avatar-user-01&orientation=squarish",
      comment: "哈哈漫画网的画质真的太棒了！而且更新速度很快，每次打开都有新内容可以看。已经推荐给身边的漫画同好了。",
      rating: 5,
      date: "2026-07-15",
    },
    {
      username: "追更达人",
      avatar: "https://readdy.ai/api/search-image?query=Close%20up%20portrait%20of%20a%20young%20Asian%20woman%20with%20long%20hair%20smiling%20warmly%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=64&height=64&seq=avatar-user-02&orientation=squarish",
      comment: "下拉式阅读体验超赞！再也不用频繁点击翻页了，一口气能看好几话。强烈推荐《密室》，剧情太烧脑了！",
      rating: 5,
      date: "2026-07-10",
    },
    {
      username: "二次元少年",
      avatar: "https://readdy.ai/api/search-image?query=Close%20up%20portrait%20of%20a%20teenage%20Asian%20boy%20with%20casual%20style%2C%20friendly%20expression%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=64&height=64&seq=avatar-user-03&orientation=squarish",
      comment: "分类很全，找漫画很方便。而且每部漫画都有简介和评分，能帮我快速筛选出想看的作品。",
      rating: 5,
      date: "2026-07-05",
    },
    {
      username: "小清新读者",
      avatar: "https://readdy.ai/api/search-image?query=Close%20up%20portrait%20of%20a%20young%20Asian%20woman%20with%20short%20bob%20haircut%2C%20gentle%20smile%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=64&height=64&seq=avatar-user-04&orientation=squarish",
      comment: "《月之泪》太好哭了555，画面美到窒息！感谢哈哈漫画网收录了这么多优质作品，我的精神食粮就靠这里了。",
      rating: 5,
      date: "2026-06-28",
    },
  ],
  contact: {
    email: "contact@hahacomic.com",
    wechat: "hahacomic2023",
    qq: "1234567890",
    workingHours: "周一至周日 9:00 - 21:00",
    address: "北京市朝阳区漫画科技大厦18层",
  },
  stats: [
    { label: "收录漫画", value: "5000+" },
    { label: "每日更新", value: "200+" },
    { label: "注册用户", value: "300万+" },
    { label: "累计阅读", value: "10亿+" },
  ],
};

export const faqData = [
  {
    question: "哈哈漫画网的漫画真的完全免费吗？",
    answer: "是的！哈哈漫画网上所有的韩国漫画内容均为免费阅读，无需任何付费即可畅读全站漫画。我们通过广告收入维持运营，致力于为读者提供无障碍的阅读体验。",
  },
  {
    question: "漫画更新的频率是怎样的？",
    answer: "我们每天都会更新漫画内容，热门连载作品通常在原作者发布后24小时内就会同步更新到平台。每日更新量超过200部作品，确保读者能够及时追更。",
  },
  {
    question: "支持哪些设备阅读？",
    answer: "哈哈漫画网支持PC端、平板和手机浏览器访问，响应式设计确保在不同设备上都有优秀的阅读体验。推荐使用Chrome或Safari浏览器获得最佳效果。",
  },
  {
    question: "如何搜索我想看的漫画？",
    answer: "您可以通过首页的搜索框直接搜索漫画名称或作者名，也可以通过分类导航浏览不同类别的漫画。我们还提供了热门推荐和最新更新板块，帮助您发现精彩内容。",
  },
  {
    question: "漫画的阅读记录会保存吗？",
    answer: "目前我们正在开发用户系统，届时将支持阅读记录、收藏夹等个性化功能。敬请期待！您也可以通过浏览器书签来保存喜欢的漫画。",
  },
];